import React, { memo } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useLanguage } from '../../../../../../../contexts/LanguageContext';
import { useClientSideSort } from '../../../../hooks/useClientSideSort';

const ChassisDetailLaborCatalogTable = ({ rows = [], loading = false }) => {
  const { th } = useLanguage();

  const { sortedData, sortField, sortOrder, onSort } = useClientSideSort(rows);

  return (
    <DataTable
      value={sortedData}
      className="p-datatable-gridlines"
      showGridlines
      paginator
      rows={5}
      onSort={onSort}
      sortField={sortField}
      sortOrder={sortOrder}
      dataKey="id"
      loading={loading}
      emptyMessage={th('warrantyClaims.detail.labor.emptyMessage')}
      rowsPerPageOptions={[5, 10, 25, 50]}
      tableStyle={{ minWidth: '40rem' }}
    >
      <Column field="laborGroupName" header={th('warrantyClaims.detail.labor.laborGroup')} sortable />
      <Column field="laborName" header={th('warrantyClaims.detail.labor.laborCatalog')} sortable />
      <Column field="description" header={th('warrantyClaims.detail.labor.description')} sortable />
      <Column field="laborTime" header={th('warrantyClaims.detail.labor.laborTime')} sortable />
    </DataTable>
  );
};

export default memo(ChassisDetailLaborCatalogTable);